<ng-container *ngIf="isLoaded">
  <div class="payment-go-ahead-pay">
    <vzpay-button
      type="1"
      text="Pay with"
      font-size="16px"
      icon="https://venueframework.s3.us-west-2.amazonaws.com/poc/vcash_white.png"
      background-color="#8cb63f"
      text-color="#ffffff"
      height="48px"
      width="300px"
      radius="4px"
    >
    </vzpay-button>
  </div>
</ng-container>
